import {environment} from '../../../../environments/environment';
import {ROUTES} from '../../../app.routes';

export abstract class FaqBase
{
    routes = ROUTES;
    protected instanceName: string;
    protected domainUrl: string;
    protected serviceTermsLink: string;

    public constructor()
    {
        this.instanceName = environment.instanceName;
        this.domainUrl = environment.domainUrl;
        this.serviceTermsLink = environment.serviceTermsLink;
    }

    public abstract getFaqs(): FaqSection[];
}

export interface QuestionAnswer
{
    question: string;
    answer: string;
}

export interface FaqSection
{
    sectionName: string;
    faqs: QuestionAnswer[];
}